import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { AdminPermissionVM } from '../dialogs/add-admin-dialog/add-amin-dialog.vm';

@Component({
  selector: 'app-admin-permissions-checkbox-group',
  templateUrl: './admin-permissions-checkbox-group.component.html',
  styleUrls: ['./admin-permissions-checkbox-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdminPermissionsCheckboxGroupComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPermissionsCheckboxGroupComponent implements ControlValueAccessor {
  protected permissionControl = new FormControl<AdminPermissionVM[] | undefined>(undefined, {
    validators: [Validators.required],
    nonNullable: true,
  });

  protected AdminPermissionVM = AdminPermissionVM;

  private onChange = (value: AdminPermissionVM[]) => {};
  private onTouched = () => {};

  public writeValue(permissions: AdminPermissionVM[]): void {
    this.permissionControl.setValue(permissions);
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  protected isCheckboxSelected(permission: AdminPermissionVM) {
    return this.permissionControl?.value?.includes(permission);
  }

  protected onCheckboxChange(option: AdminPermissionVM): void {
    if (this.permissionControl?.value?.includes(option)) {
      this.permissionControl.patchValue(this.permissionControl.value.filter((permission) => permission !== option));
    } else {
      this.permissionControl.patchValue([...(this.permissionControl.value ?? []), option]);
    }
    this.onChange(this.permissionControl?.value ?? []);
    this.onTouched();
    this.permissionControl.markAsTouched();
  }
}
